"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MiniMap = require("../MiniMap/MiniMap");

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _utils = require("../../common/utils");

var _utils2 = _interopRequireDefault(_utils);

var _PanelSelectEstacions = require("./PanelSelectEstacions.css");

var _PanelSelectEstacions2 = _interopRequireDefault(_PanelSelectEstacions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     
//import "@babel/polyfill";


var PanelSelectEstacions = function (_Component) {
	_inherits(PanelSelectEstacions, _Component);

	function PanelSelectEstacions(props) {
		_classCallCheck(this, PanelSelectEstacions);

		var _this = _possibleConstructorReturn(this, (PanelSelectEstacions.__proto__ || Object.getPrototypeOf(PanelSelectEstacions)).call(this, props));

		_this.saveToLocal = function () {
			localStorage.setItem(CONSTANTS.CACHED_STATIONS_DATA, JSON.stringify({
				fontsSet: [].concat(_toConsumableArray(_this.state.fontsSet)),
				comarquesSet: [].concat(_toConsumableArray(_this.state.comarquesSet)),
				loadedData: _this.state.loadedData
			}));

			_this.props.updateJsonConfig("selectedorganizations", [].concat(_toConsumableArray(_this.state.fontsSet)));
		};

		_this.handleSort = function (clickedColumn) {
			return function () {
				var _this$state = _this.state,
				    sortedColumn = _this$state.sortedColumn,
				    sortedDirection = _this$state.sortedDirection,
				    loadedData = _this$state.loadedData;


				if (sortedColumn !== clickedColumn) {

					loadedData.features = loadedData.features.sort(function (a, b) {
						return a.properties[clickedColumn].toLowerCase().trim().localeCompare(b.properties[clickedColumn].toLowerCase().trim());
					});
					_this.setState({
						sortedColumn: clickedColumn,
						loadedData: loadedData,
						sortedDirection: "ascending"
					});
				} else {

					loadedData.features = loadedData.features.reverse();
					_this.setState({
						loadedData: loadedData,
						sortedDirection: sortedDirection === "ascending" ? "descending" : "ascending"
					});
				}
			};
		};

		_this.handleChange = function (iscat, event, data) {

			var selectedStations = _this.state.selectedstationsids;
			var loadedData = _this.state.loadedData;

			if (data.checked) {

				selectedStations.add(data.id);
			} else {
				selectedStations.delete(data.id);
			}

			loadedData.features[data.index].properties.selected = data.checked;
			_this.setState({ selectedstationsids: selectedStations, loadedData: loadedData, iscat: data.checked ? _this.state.iscat && iscat : _this.state.iscat });
			_this.map.setData(loadedData);
			_this.saveToLocal();
		};

		_this.state = {
			selectedstationsids: new Set(props.selectedstationsids),
			sortedColumn: null,
			sortedDirection: null,
			loadedData: null,
			comarquesSet: new Set(),
			comarquesSetVal: [],
			fontsSet: new Set(),
			fontsSetVal: [],
			loading: true,
			showError: false,
			errorMsg: "",
			missingSelectedFields: false,
			randomNumber: 100,
			iscat: props.iscat
		};

		_this.cachedStationsList = localStorage.getItem(CONSTANTS.CACHED_STATIONS_DATA);
		return _this;
	}

	_createClass(PanelSelectEstacions, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			if (!this.cachedStationsList || this.cachedStationsList === "[]") {
				this.loadStations();
			} else {

				var cachedStationsListObject = JSON.parse(this.cachedStationsList);

				this.map.setData(cachedStationsListObject.loadedData);

				this.setState({
					loading: false,
					fontsSet: cachedStationsListObject.fontsSet,
					comarquesSet: cachedStationsListObject.comarquesSet,
					loadedData: cachedStationsListObject.loadedData
				});
			}
		}
	}, {
		key: "loadStations",
		value: function loadStations() {
			var _this2 = this;

			var data = this.props.data;


			var nameDB = data.isCSVFile ? data.databasename : "" + data.databasename + CONSTANTS.SUFIX_STATIONS;

			_request2.default.get(CONSTANTS.URL_GET_STATIONS + "/" + nameDB + "/stationspoints").then(function (data) {

				var selectedStations = _this2.state.selectedstationsids;
				var comarquesSet = _this2.state.comarquesSet;
				var fontsSet = _this2.state.fontsSet;

				var stationsList = { "type": "FeatureCollection", "features": [] };

				/* data.features.forEach((feature, index) => {
    		const parseComarca = Utils.parseStringFromHtml(feature.properties.comarca);
    	const parseFont = Utils.parseStringFromHtml(feature.properties.font);
    	const parseNom = Utils.parseStringFromHtml(feature.properties.nomok);
    		if (feature.properties.comarca !== null) comarquesSet.add(parseComarca);
    	if (feature.properties.font !== null) fontsSet.add(parseFont);
    		stationsList.features.push({
    		...feature,
    		properties: {
    			...feature.properties,
    			selected: selectedStations.has(feature.properties.id),
    			index,
    			nomok: parseNom,
    			comarca: parseComarca,
    			font: parseFont
    			}
    	});
    	}); */

				stationsList.features = data.features.map(function (feature, index) {

					var parseComarca = _utils2.default.parseStringFromHtml(feature.properties.comarca);
					var parseFont = _utils2.default.parseStringFromHtml(feature.properties.font);
					var parseNom = _utils2.default.parseStringFromHtml(feature.properties.nomok);

					if (feature.properties.comarca !== null) comarquesSet.add(parseComarca);
					if (feature.properties.font !== null) fontsSet.add(parseFont);

					return _extends({}, feature, {
						properties: _extends({}, feature.properties, {
							selected: selectedStations.has(feature.properties.id),
							index: index,
							nomok: parseNom,
							comarca: parseComarca,
							font: parseFont

						})
					});
				});

				_this2.map.setData(stationsList);

				_this2.setState({
					loading: false,
					selectedstationsids: selectedStations,
					comarquesSet: comarquesSet,
					loadedData: stationsList
				}, _this2.saveToLocal);
			}).catch(function (err) {

				_this2.setState({ loading: false, showError: true, errorMsg: err });
			});
		}
	}, {
		key: "renderStations",
		value: function renderStations() {
			var _this3 = this;

			var loadedData = this.state.loadedData;


			return loadedData.features.map(function (station, i) {
				return _react2.default.createElement(
					_semanticUiReact.Table.Row,
					{ key: i },
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						_react2.default.createElement(_semanticUiReact.Checkbox, { checked: station.properties.selected, onChange: _this3.handleChange.bind(_this3, station.properties.iscat), id: station.properties.id, index: i })
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						station.properties.nomok
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						station.properties.comarca
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						station.properties.font
					)
				);
			});
		}
	}, {
		key: "renderStationsList",
		value: function renderStationsList() {
			var _this4 = this;

			var _state = this.state,
			    column = _state.column,
			    sortedDirection = _state.sortedDirection;

			var style = { width: "99%" };
			var columnStateStyle = { width: "60px" };

			if (this.state.loading) {
				return _react2.default.createElement(_semanticUiReact.Loader, { active: true });
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}

			var color = "teal";

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					_semanticUiReact.Table,
					{ style: style, color: color, key: color, columns: 4, fixed: true, sortable: true, selectable: true, verticalAlign: "middle" },
					_react2.default.createElement(
						_semanticUiReact.Table.Header,
						{ className: _PanelSelectEstacions2.default.myTableHeader, color: color, key: color },
						_react2.default.createElement(
							_semanticUiReact.Table.Row,
							null,
							_react2.default.createElement(
								_semanticUiReact.Table.HeaderCell,
								{ style: columnStateStyle, sorted: column === "estat" ? sortedDirection : null },
								_react2.default.createElement(_semanticUiReact.Checkbox, { onClick: function onClick(event, data) {
										return _this4.state.selectedstationsids.size !== 0 && !data.checked ? _this4.handleSelectNone() : _this4.handleSelectAll();
									}, label: "" })
							),
							_react2.default.createElement(
								_semanticUiReact.Table.HeaderCell,
								{ sorted: column === "nomok" ? sortedDirection : null, onClick: this.handleSort("nomok") },
								"Nom"
							),
							_react2.default.createElement(
								_semanticUiReact.Table.HeaderCell,
								{ sorted: column === "comarca" ? sortedDirection : null, onClick: this.handleSort("comarca") },
								"Comarca"
							),
							_react2.default.createElement(
								_semanticUiReact.Table.HeaderCell,
								{ sorted: column === "font" ? sortedDirection : null, onClick: this.handleSort("font") },
								"Font"
							)
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Body,
						null,
						this.renderStations()
					)
				)
			);
		}
	}, {
		key: "handleRandomNumberChange",
		value: function handleRandomNumberChange(e) {

			this.setState({ randomNumber: parseInt(e.target.value) });
		}
	}, {
		key: "handleFontChange",
		value: function handleFontChange(event, dropdownData) {

			var data = this.state.loadedData;
			var drowdownValues = dropdownData.value instanceof Array ? dropdownData.value : [dropdownData.value];

			var selectedStations = new Set();

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				var _loop = function _loop() {
					var elem = _step.value;


					var shouldBeSelected = drowdownValues.find(function (ddData) {
						return elem.properties.font === ddData;
					}) !== undefined;
					if (shouldBeSelected) {

						selectedStations.add(elem.properties.id);
					}
					elem.properties.selected = shouldBeSelected;
				};

				for (var _iterator = data.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					_loop();
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.setState({ selectedstationsids: selectedStations, loadedData: data, comarquesSetVal: "", fontsSetVal: drowdownValues, iscat: false });
			this.map.setData(data);
			this.saveToLocal();
		}
	}, {
		key: "handleComarcaChange",
		value: function handleComarcaChange(event, dropdownData) {

			var data = this.state.loadedData;
			var drowdownValues = dropdownData.value instanceof Array ? dropdownData.value : [dropdownData.value];

			var selectedStations = new Set();
			//const selectedStations = new Set(this.state.selectedstationsids.entries());

			data.features.forEach(function (elem) {
				var shouldBeSelected = drowdownValues.find(function (ddData) {
					return elem.properties.comarca === ddData;
				}) !== undefined;

				if (shouldBeSelected) {

					selectedStations.add(elem.properties.id);
				}
				elem.properties.selected = shouldBeSelected;
			});

			/* for (const elem of data.features) {
   		const shouldBeSelected = (drowdownValues.find(ddData => elem.properties.font === ddData) !== undefined);
   	if (shouldBeSelected) {
   			selectedStations.add(elem.properties.id);
   		}
   	elem.properties.selected = shouldBeSelected;
   } */

			this.setState({ selectedstationsids: selectedStations, loadedData: data, comarquesSetVal: drowdownValues, fontsSetVal: "", iscat: false });
			this.map.setData(data);
			this.saveToLocal();
		}
	}, {
		key: "handleSelectAll",
		value: function handleSelectAll() {

			var data = this.state.loadedData;
			var selectedStations = this.state.selectedstationsids;

			data.features.forEach(function (elem) {

				selectedStations.add(elem.properties.id);
				elem.properties.selected = true;
			});

			this.setState({ selectedstationsids: selectedStations, loadedData: data, comarquesSetVal: "", fontsSetVal: "", iscat: false });
			this.map.setData(data);
			this.saveToLocal();
		}
	}, {
		key: "handleSelectNone",
		value: function handleSelectNone() {

			var data = this.state.loadedData;
			var selectedStations = new Set();

			data.features.forEach(function (elem) {

				elem.properties.selected = false;
			});

			this.setState({ selectedstationsids: selectedStations, loadedData: data, comarquesSetVal: "", fontsSetVal: "", iscat: false });
			this.map.setData(data);
			this.saveToLocal();
		}
	}, {
		key: "randomSelection",
		value: function randomSelection() {

			var rand = this.state.randomNumber;
			var data = this.state.loadedData;

			var selectedStations = new Set();

			data.features.forEach(function (elem) {
				return elem.properties.selected = false;
			});
			while (selectedStations.size < rand) {

				var index = Math.floor(Math.random() * data.features.length);
				selectedStations.add(data.features[index].properties.id);
				data.features[index].properties.selected = true;
			}

			this.setState({ selectedstationsids: selectedStations, loadedData: data, comarquesSetVal: "", fontsSetVal: "", iscat: false });
			this.map.setData(data);
			this.saveToLocal();
		}
	}, {
		key: "clickStation",
		value: function clickStation(e) {

			var id = e.features[0].properties.id;
			var arrayIndex = e.features[0].properties.index;
			var selectedStations = this.state.selectedstationsids;
			var loadedData = this.state.loadedData;
			var feature = loadedData.features[arrayIndex];

			if (selectedStations.has(id)) {

				selectedStations.add(id);
			} else {

				selectedStations.delete(id);
			}

			feature.properties.selected = !feature.properties.selected;
			this.setState({ selectedstationsids: selectedStations, loadedData: loadedData, iscat: feature.properties.selected ? this.state.iscat && feature.properties.iscat : this.state.iscat });
			this.map.setData(loadedData);
			this.saveToLocal();
		}
	}, {
		key: "moveHandle",
		value: function moveHandle(e, layerName) {

			var features = this.map.queryRenderedFeatures(e.point, layerName);
			this.map.setCursor(features.length !== 0 ? "pointer" : "default");
		}
	}, {
		key: "renderItemSeleccioFont",
		value: function renderItemSeleccioFont() {
			var _this5 = this;

			var dropdownOptions = [];

			this.state.fontsSet.forEach(function (text, index) {
				dropdownOptions.push({
					key: index,
					text: text.trim(),
					value: text.trim()
				});
			});

			dropdownOptions = dropdownOptions.sort(function (a, b) {
				return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
			});

			return _react2.default.createElement(
				_semanticUiReact.Item,
				null,
				_react2.default.createElement(
					_semanticUiReact.Item.Content,
					{ className: _PanelSelectEstacions2.default.myDropdown },
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(_semanticUiReact.Icon, { name: "caret right" }),
						"Selecciona per font:"
					),
					_react2.default.createElement(_semanticUiReact.Dropdown, {
						fluid: true,
						button: true,
						className: "icon",
						floating: true,
						labeled: true,
						icon: "plus circle",
						search: true,
						multiple: true, selection: true,
						value: this.state.fontsSetVal,
						options: dropdownOptions,
						onChange: function onChange(e, data) {
							return _this5.handleFontChange(e, data);
						},
						ref: function ref(instance) {
							return _this5.dropDown = instance;
						}
					})
				)
			);
		}
	}, {
		key: "onSelectCat",
		value: function onSelectCat(isChecked) {

			var data = this.state.loadedData;
			var selectedStations = new Set();

			data.features.forEach(function (elem) {
				var shouldBeSelected = isChecked && elem.properties.iscat;

				if (shouldBeSelected) {

					selectedStations.add(elem.properties.id);
				}
				elem.properties.selected = shouldBeSelected;
			});

			this.setState({ selectedstationsids: selectedStations, loadedData: data, iscat: isChecked, comarquesSetVal: "", fontsSetVal: "" });
			this.map.setData(data);
		}
	}, {
		key: "renderItemSeleccioComarca",
		value: function renderItemSeleccioComarca() {
			var _this6 = this;

			var dropdownOptions = [];

			this.state.comarquesSet.forEach(function (text, index) {
				dropdownOptions.push({
					key: index,
					text: text.trim(),
					value: text.trim()
				});
			});

			dropdownOptions = dropdownOptions.sort(function (a, b) {
				return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
			});

			return _react2.default.createElement(
				_semanticUiReact.Item,
				null,
				_react2.default.createElement(
					_semanticUiReact.Item.Content,
					{ className: _PanelSelectEstacions2.default.myDropdown },
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(_semanticUiReact.Icon, { name: "caret right" }),
						"Selecciona per territori (Catalunya o comarques):"
					),
					_react2.default.createElement(
						"div",
						{ className: _PanelSelectEstacions2.default.containerSelectCat },
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							checked: this.state.iscat,
							onChange: function onChange(e, data) {
								return _this6.onSelectCat(data.checked);
							},
							label: "Nom\xE9s Catalunya",
							toggle: true
						})
					),
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(_semanticUiReact.Dropdown, {
							fluid: true,
							button: true,
							className: "icon",
							floating: true,
							placeholder: "selecciona comarca...",
							labeled: true,
							icon: "map pin",
							search: true,
							multiple: true, selection: true,
							value: this.state.comarquesSetVal,
							options: dropdownOptions,
							onChange: function onChange(e, data) {
								return _this6.handleComarcaChange(e, data);
							},
							ref: function ref(instance) {
								return _this6.dropDown = instance;
							}
						})
					)
				)
			);
		}
	}, {
		key: "renderSeleccioTotes",
		value: function renderSeleccioTotes() {
			var _this7 = this;

			return _react2.default.createElement(
				_semanticUiReact.Item,
				null,
				_react2.default.createElement(
					_semanticUiReact.Item.Content,
					null,
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(_semanticUiReact.Icon, { name: "caret right" }),
						"Selecciona totes les estacions:"
					),
					_react2.default.createElement(
						_semanticUiReact.Button.Group,
						{ fluid: true },
						_react2.default.createElement(
							_semanticUiReact.Button,
							{ color: "teal", onClick: function onClick(e) {
									return _this7.handleSelectAll();
								} },
							_react2.default.createElement(_semanticUiReact.Icon, { name: "check square" }),
							"Seleccionar totes"
						),
						_react2.default.createElement(_semanticUiReact.Button.Or, { text: "\xF3" }),
						_react2.default.createElement(
							_semanticUiReact.Button,
							{ onClick: function onClick(e) {
									return _this7.handleSelectNone();
								} },
							_react2.default.createElement(_semanticUiReact.Icon, { name: "square outline" }),
							"Netejar la selecci\xF3"
						)
					)
				)
			);
		}
	}, {
		key: "renderItemSeleccioAleatoria",
		value: function renderItemSeleccioAleatoria() {
			var _this8 = this;

			if (this.props.data.databasename !== CONSTANTS.DB_TEMPS_ACTUAL) return;

			return _react2.default.createElement(
				_semanticUiReact.Item,
				null,
				_react2.default.createElement(
					_semanticUiReact.Item.Content,
					null,
					_react2.default.createElement(
						"p",
						null,
						_react2.default.createElement(_semanticUiReact.Icon, { name: "caret right" }),
						"Introdueix el nombre d'estacions a seleccionar de forma aleat\xF2ria:"
					),
					_react2.default.createElement(_semanticUiReact.Input, {
						fluid: true,
						value: this.state.randomNumber,
						onChange: function onChange(e) {
							return _this8.handleRandomNumberChange(e);
						},
						action: { color: "teal", content: "Selecciona", onClick: function onClick(e) {
								return _this8.randomSelection();
							} } })
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this9 = this;

			return _react2.default.createElement(
				_semanticUiReact.Container,
				{ fluid: true, className: _PanelSelectEstacions2.default.containerStyle, textAlign: "justified" },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						_semanticUiReact.Header,
						{ as: "h3" },
						CONSTANTS.STEPS[this.props.myStep].description
					),
					this.state.missingSelectedStations && _react2.default.createElement(
						_semanticUiReact.Message,
						{ negative: true },
						_react2.default.createElement(
							"p",
							null,
							"Si us plau, selecciona alguna estaci\xF3 per continuar"
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Grid,
						{ className: _PanelSelectEstacions2.default.myGrid, stackable: true, container: true, columns: 2 },
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 9, className: _PanelSelectEstacions2.default.tableColumnStyle },
							this.renderStationsList()
						),
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 7 },
							_react2.default.createElement(
								_semanticUiReact.Segment,
								null,
								_react2.default.createElement(
									_semanticUiReact.Header,
									{ as: "h3" },
									_react2.default.createElement(_semanticUiReact.Icon, { name: "filter" }),
									_react2.default.createElement(
										_semanticUiReact.Header.Content,
										null,
										"Filtres:"
									)
								),
								_react2.default.createElement(
									_semanticUiReact.Item.Group,
									{ divided: true, unstackable: true },
									this.renderItemSeleccioFont(),
									this.renderItemSeleccioComarca(),
									this.renderItemSeleccioAleatoria(),
									_react2.default.createElement(
										_semanticUiReact.Item,
										null,
										_react2.default.createElement(
											_semanticUiReact.Item.Content,
											null,
											_react2.default.createElement(
												"p",
												null,
												_react2.default.createElement(_semanticUiReact.Icon, { name: "caret right" }),
												"Selecciona al mapa fent click sobre una estaci\xF3 o fent shift + click per definir una \xE0rea"
											),
											_react2.default.createElement(
												"div",
												{ className: _PanelSelectEstacions2.default.myMap },
												_react2.default.createElement(_MiniMap2.default, { ref: function ref(instance) {
														return _this9.map = instance;
													}, onClickHandle: function onClickHandle(e) {
														return _this9.clickStation(e);
													}, onMoveHandle: function onMoveHandle(e, layerName) {
														return _this9.moveHandle(e, layerName);
													} })
											)
										)
									)
								)
							)
						)
					)
				)
			);
		}
	}, {
		key: "isValid",
		value: function isValid() {

			var emptySelection = this.state.selectedstationsids.size === 0;

			this.setState({ missingSelectedStations: emptySelection });

			return !emptySelection;
		}
	}, {
		key: "getJsonconfigState",
		value: function getJsonconfigState() {

			return {
				prop: ["selectedstationsids", "iscat"],
				data: [[].concat(_toConsumableArray(this.state.selectedstationsids)), this.state.iscat]
			};
		}
	}]);

	return PanelSelectEstacions;
}(_react.Component);

exports.default = PanelSelectEstacions;


PanelSelectEstacions.propTypes = {
	selectedstationsids: _propTypes2.default.array, // .arrayOf(PropTypes.number),
	iscat: _propTypes2.default.bool,
	myStep: _propTypes2.default.number,
	updateJsonConfig: _propTypes2.default.func,
	timerange: _propTypes2.default.object,
	data: _propTypes2.default.object
};
